import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import { ThunkDispatch } from 'redux-thunk';
import authSlice from './reducers/authReducer/authSlice';
import mailboxSlice from './reducers/mailboxReducer/mailboxSlice';
import notificationsSlice from './reducers/notificationsReducer/notificationsSlice';
import contextualHelpSlice from './reducers/contextualHelpReducer/contextualHelpSlice';
import assessmentSessionSlice from './reducers/assessmentSessionReducer/assessmentSessionSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import filtersSlice from './reducers/filtersReducer/filtersSlice';

const persistConfig = {
  key: 'root',
  // In my opinion filters should be short lived.
  // Without blaclisting them we are storing this data additionally in localStorage which can be quite slow
  // for our ammount of data in filters. In case of error user need to logout and sign in again to clear this.
  // blacklist: ['filters'],
  storage,
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authSlice.reducer,
    mailbox: mailboxSlice.reducer,
    notifications: notificationsSlice.reducer,
    contextualHelp: contextualHelpSlice.reducer,
    assessmentSession: assessmentSessionSlice.reducer,
    filters: filtersSlice.reducer,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/storeUser', 'persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: ['auth.user', 'payload.user', 'register', 'rehydrate'],
        ignoredPaths: ['auth.user'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type StoreType = typeof store;
export type AppDispatch = typeof store.dispatch & ThunkDispatch<RootState, unknown, AnyAction>;

export default store;
export const persistor = persistStore(store);
